import DataTable from "react-data-table-component";
import { optometryColumnStore } from "../js/tableColumns";
import { useOptometryHistory } from "../hooks/useOptometryHistory";

export default function PrescriptionList({ patientId, onSelect }) {
  const optometriesList = useOptometryHistory(patientId, 1, "Gafas");

  return (
    <div
      className="extra-container dashboard-summary-table"
      style={{ minWidth: "330px" }}
    >
      <DataTable
        columns={optometryColumnStore}
        data={optometriesList}
        className="custom-datatable dashboard-custom-table"
        noDataComponent="No existen datos."
        onRowClicked={(row) => {
          onSelect(row);
        }}
      />
    </div>
  );
}
